exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hesuan[data-v-07f99b82]{margin-top:.2rem;padding:.1rem;border-radius:10px;color:#fff}.hesuanBorder[data-v-07f99b82]{border-radius:10px;padding:.3rem 0;border:1px solid #fff}.health-container[data-v-07f99b82]{max-height:13rem;overflow:auto}", ""]);

// exports
